var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.243 12H7.757m13.493 0a9.25 9.25 0 11-18.5 0 9.25 9.25 0 0118.5 0z",
    stroke: "#5F6A7D",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJQcm9wZXJ0eSAxPVJFTU9WRSI+CjxwYXRoIGlkPSJJY29uIiBkPSJNMTYuMjQyNiAxMi4wMDA1SDcuNzU3MzZNMjEuMjUgMTJDMjEuMjUgMTcuMTA4NiAxNy4xMDg2IDIxLjI1IDEyIDIxLjI1QzYuODkxMzcgMjEuMjUgMi43NSAxNy4xMDg2IDIuNzUgMTJDMi43NSA2Ljg5MTM3IDYuODkxMzcgMi43NSAxMiAyLjc1QzE3LjEwODYgMi43NSAyMS4yNSA2Ljg5MTM3IDIxLjI1IDEyWiIgc3Ryb2tlPSIjNUY2QTdEIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8L2c+Cjwvc3ZnPgo=";
export { SvgRemove as ReactComponent };